/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OAuthCallbackPayload } from '../models/OAuthCallbackPayload';
import type { SoftwareAuthorizationOut } from '../models/SoftwareAuthorizationOut';
import type { SoftwareAuthorizationStartData } from '../models/SoftwareAuthorizationStartData';
import type { SoftwareAuthorizationStep_Union_dict__NoneType__ } from '../models/SoftwareAuthorizationStep_Union_dict__NoneType__';
import type { SoftwareBase } from '../models/SoftwareBase';
import type { SoftwareOut } from '../models/SoftwareOut';
import type { SoftwarePostIn } from '../models/SoftwarePostIn';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SoftwareAuthorizationService {
    /**
     * Register Oauth Software
     * @returns SoftwareBase Successful Response
     * @throws ApiError
     */
    public static registerOauthSoftwareApiV1OauthOauthRegisterPost({
        requestBody,
        fullReload = false,
        xTransactionId,
    }: {
        requestBody: OAuthCallbackPayload,
        fullReload?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<SoftwareBase> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/oauth/oauth_register',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'full_reload': fullReload,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Authorize Software
     * @returns string Successful Response
     * @throws ApiError
     */
    public static startAuthorizeSoftwareApiV1SoftwareAuthorizeStartPost({
        requestBody,
        xTransactionId,
    }: {
        requestBody: SoftwareAuthorizationStartData,
        xTransactionId?: (string | null),
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/software/authorize/start',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Authorize Software Step
     * @returns SoftwareAuthorizationOut Successful Response
     * @throws ApiError
     */
    public static authorizeSoftwareStepApiV1SoftwareAuthorizeStepPost({
        requestBody,
        xTransactionId,
    }: {
        requestBody: SoftwareAuthorizationStep_Union_dict__NoneType__,
        xTransactionId?: (string | null),
    }): CancelablePromise<SoftwareAuthorizationOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/software/authorize/step',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Software
     * @returns SoftwareOut Successful Response
     * @throws ApiError
     */
    public static postSoftwareApiV1SoftwareSoftwarePost({
        requestBody,
        fullReload = false,
        xTransactionId,
    }: {
        requestBody: SoftwarePostIn,
        fullReload?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<SoftwareOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/software/software',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'full_reload': fullReload,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reauthorize Software
     * @returns SoftwareBase Successful Response
     * @throws ApiError
     */
    public static reauthorizeSoftwareApiV1SoftwareSoftwareIdReauthorizePost({
        softwareId,
        requestBody,
        xTransactionId,
    }: {
        softwareId: string,
        requestBody: Record<string, any>,
        xTransactionId?: (string | null),
    }): CancelablePromise<SoftwareBase> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/software/{software_id}/reauthorize',
            path: {
                'software_id': softwareId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get
     * Get the OAuth login link for a specific integration. This is used to start the OAuth flow.
     *
     * An OAuthState is created and stored in the database. This is used to prevent CSRF attacks.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getApiV1OauthOauthLinkGet({
        softwareName,
        readOnly,
        xTransactionId,
    }: {
        softwareName: string,
        readOnly: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oauth/oauth_link',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'software_name': softwareName,
                'read_only': readOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Oauth Link To Reauthorize Software
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getOauthLinkToReauthorizeSoftwareApiV1OauthReauthorizeSoftwareIdGet({
        softwareId,
        xTransactionId,
    }: {
        softwareId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oauth/reauthorize/{software_id}',
            path: {
                'software_id': softwareId,
            },
            headers: {
                'x-transaction-id': xTransactionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Oauth
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshOauthApiV1OauthRefreshGet({
        softwareId,
        xTransactionId,
    }: {
        softwareId: string,
        xTransactionId?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/oauth/refresh',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'software_id': softwareId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
